import React from "react";
import Accessibility from "../../components/UI/Accessibility";
import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import {
  Container,
  ContentText,
  Images,
  LinkDoc,
  Text,
  Title,
  ViewImages,
} from "./styles";
import Banner from "../../components/UI/Banner";
import { images } from "../../constants";

import programaaprende from "../../assets/docs/programa_aprendemaismogi.pdf";
import decretoaprende from "../../assets/docs/decreto_aprendemaismogi.pdf";
import resolucaoaprende from "../../assets/docs/resolucao_aprendemaismogi.pdf";

import recovery1 from "../../assets/images/recovery1.jpg";
import recovery2 from "../../assets/images/recovery2.jpg";

const ProjectRecovery = () => {
  return (
    <Container>
      <Menu />
      <Banner icon={images.icon_student}>Aprende + Mogi</Banner>
      <ContentBox>
        <ContentText>

          <Title>
            PROGRAMA DE RECUPERAÇÃO DAS APRENDIZAGENS
          </Title>

          <ViewImages>
            <Images src={recovery1} />
            <Images src={recovery2} />
          </ViewImages>

          <Text>
            O Programa Municipal de Recuperação das Aprendizagens - Aprende Mais Mogi
            representa um compromisso da Secretaria Municipal de Educação de Mogi das 
            Cruzes em garantir que todos os estudantes avancem com segurança e autonomia
            em sua trajetória escolar.
          </Text>

          <Text>
            A aprendizagem deve ser compreendida como um processo individual e contínuo,
            respeitando os tempos e ritmos de cada estudante. Como ressalta Telma Weisz
            (2002, p. 65): “Não é o processo de aprendizagem que deve se adaptar ao de 
            ensino, mas o processo de ensino é que tem de se adaptar ao de aprendizagem.
            Ou melhor: o processo de ensino deve dialogar com o de aprendizagem”. Ao unir
            estratégias pedagógicas estruturadas, formação docente de qualidade e 
            monitoramento, este programa se configura como uma ação concreta para 
            assegurar o direito à educação de qualidade para todos.
          </Text>
            
          <Text>

            A colaboração entre Secretaria Municipal de Educação, gestores, professores,
            famílias e comunidade escolar será fundamental para o êxito da iniciativa.
                    
          </Text>

          <LinkDoc href={programaaprende} target="_blank">* Conheça o projeto (Clique aqui)</LinkDoc>
          <LinkDoc href={decretoaprende} target="_blank">* Decreto Aprende Mais Mogi (Clique aqui)</LinkDoc>
          <LinkDoc href={resolucaoaprende} target="_blank">* Resolução Aprende Mais Mogi (Clique aqui)</LinkDoc>
  
        </ContentText>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default ProjectRecovery;